import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getFeatureFlags, setFeatureFlag } from 'utils/featureFlags';
import isFeatureEnabled from 'selectors/isFeatureEnabled';
import { FEATURE_FLAG_TOGGLE, FEATURE_FLAGS_LOAD } from './types';
import { loadFeatureFlagsSuccess, loadFeatureFlagsFailure } from './actions';

/**
 * Persists the value of feature flag to external storage.
 *
 * This is an example of saga handling pure side effects.
 *
 * @param {Object} action `FEATURE_FLAG_TOGGLE` action
 */
function* featureFlagToggleSaga(action) {
  const { id } = action.payload;

  // Saga happens after reducer, so we are getting the updated value here
  const isEnabled = yield select(isFeatureEnabled, id);

  // Persist the flag
  yield call(setFeatureFlag, id, isEnabled);
}

/**
 * Load feature flags from remote service.
 *
 * @param {Object} action `FEATURE_FLAGS_LOAD` action
 */
function* featureFlagLoadSaga(action) {
  try {
    const { userId, attributes } = action.payload;
    const flags = yield call(getFeatureFlags, userId, attributes);
    yield put(loadFeatureFlagsSuccess(flags));
  } catch (error) {
    yield put(loadFeatureFlagsFailure(error));
  }
}

export default function* saga() {
  yield takeEvery(FEATURE_FLAG_TOGGLE, featureFlagToggleSaga);
  yield takeEvery(FEATURE_FLAGS_LOAD, featureFlagLoadSaga);
}
